import { render, staticRenderFns } from "./FiltersSidebarOnlyCorrect.vue?vue&type=template&id=33fd12fa&"
import script from "./FiltersSidebarOnlyCorrect.vue?vue&type=script&lang=js&"
export * from "./FiltersSidebarOnlyCorrect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCheckbox,VSlideYTransition})
